module.exports = __webpack_public_path__ + "static/media/RuskinLogo.3948d092.png";